module.exports = __webpack_public_path__ + "assets/img/pdf-cover.b264115d.png";